import { OptionPicker } from '@vfde-brix/ws10/option-picker';
import {
    getSessionStorageItemJson,
    setSessionStorageItemJson,
} from '@vfde-sails/storage';
import {
    SAILS_BNT_STORAGE,
    SalesChannel,
    SALESCHANNEL_CONSUMER,
    SALESCHANNEL_YOUNG,
} from '@vfde-sails/constants';
import NAMESPACE from 'Constant';
import { SailsTariffOverviewStorage } from 'Container/App/interface';
import {
    setGigakombi,
    setSalesChannel,
} from 'Container/App/slice';

/**
 * Sets the focus on the option picker option that triggered the redirection
 *
 * The user can now continue their tab flow.
 */
export const restoreFocusAfterRedirect = (
    optionPickers: Record<typeof setGigakombi.type | typeof setSalesChannel.type, OptionPicker | null>,
): void => {
    const storage = getSessionStorageItemJson<SailsTariffOverviewStorage>(SAILS_BNT_STORAGE);

    // Skip rest of function in case there is no focus to restore
    if (!storage || !storage[NAMESPACE]?.restoreFocus) {
        return;
    }

    const configuration = Object.entries(storage[NAMESPACE].restoreFocus)[0];

    // Skip rest of the function in case the restoreFocus property has an invalid configuration
    if (!isValid(configuration)) {
        return;
    }

    const [key, value] = configuration;

    // Restore focus
    optionPickers[key]?.focusOptionByValue(value);

    // Remove the configuration from the session storage, so it won't be interfering with a reload
    delete storage[NAMESPACE].restoreFocus;
    setSessionStorageItemJson(SAILS_BNT_STORAGE, storage);

    // Scroll the option picker into view
    document.activeElement?.scrollIntoView({
        behavior: 'auto',
        block: 'center',
    });
};

const isValid = (
    configuration: [string, string],
): configuration is [
    typeof setSalesChannel.type | typeof setGigakombi.type,
    'true' | 'false' | Extract<SalesChannel, typeof setGigakombi.type | typeof setSalesChannel.type>,
] => {
    const [key, value] = configuration;

    if (![setGigakombi.type, setSalesChannel.type].includes(key as any)) {
        return false;
    }

    if (key === setSalesChannel.type && ![SALESCHANNEL_YOUNG, SALESCHANNEL_CONSUMER].includes(value)) {
        return false;
    }

    return !(key === setGigakombi.type && !['true', 'false'].includes(value));
};
